import { useSelector } from 'react-redux';
import StagedProgressBar from './StagedProgressBar';
import {
  getCurrentStageIndex,
  checkStageStatus,
} from './StagedProgressBar.helpers';
import StartIcon from './icons/StartIcon';
import RequirementsIcon from './icons/RequirementsIcon';
import ContactInfoIcon from './icons/ContactInfoIcon';
import FinishIcon from './icons/FinishIcon';

const StagedProgressBarContainer = ({ stages, currentPage }) => {
  const isFinalPageBeforeSubmission = useSelector(
    (store) => store.navigation.isFinalPageBeforeSubmission
  );

  const stageIcons = {
    start: StartIcon,
    requirements: RequirementsIcon,
    contactInfo: ContactInfoIcon,
    finish: FinishIcon,
  };

  const stagesWithIcons = stages.map((stage) => {
    if (stage.icon) return stage;

    const IconComponent = stageIcons[stage.id];
    return {
      ...stage,
      icon: IconComponent ? <IconComponent /> : null,
    };
  });

  const currentStageIndex = getCurrentStageIndex(
    stagesWithIcons,
    currentPage,
    isFinalPageBeforeSubmission
  );

  const enrichedStages = stagesWithIcons.map((stage, index) => {
    const status = checkStageStatus(
      stage,
      index,
      currentStageIndex,
      isFinalPageBeforeSubmission
    );
    return { ...stage, status };
  });

  return <StagedProgressBar stages={enrichedStages} />;
};

export default StagedProgressBarContainer;
